import EditableContent from "@/components/DataTable/components/DataTableContainer/Components/DataTableBody/Components/EditableContent";
import lightTheme from "@/views/AdminView/theme/light";
import { CheckIcon, PencilIcon, XMarkIcon } from "@heroicons/react/24/outline";
import {
    Box,
    Card,
    CardContent,
    IconButton,
    TextField,
    ThemeProvider,
    Typography,
    styled,
    useTheme,
} from "@mui/material";
import { useEffect, useState } from "react";
import { ContentBlockData } from "./ContentBlockTool";

const InputButton = styled(IconButton)(() => ({
    backgroundColor: "unset",
    padding: 0,
    marginLeft: 10,
    "&:hover": {
        color: "#000000",
        backgroundColor: "unset",
    },
}));

export interface ContentBlockComponentProps {
    data: ContentBlockData;
    onChange: (data: ContentBlockData) => void;
}

export const ContentBlockComponent = ({ data, onChange }: ContentBlockComponentProps) => {
    const [initialized, setInitialized] = useState<boolean>(false);
    const [edit, setEdit] = useState<boolean>(false);
    const [id, setId] = useState<string>("");
    const [confirmedId, setConfirmedId] = useState<string>("");

    const theme = useTheme();

    useEffect(() => {
        setId(data.id);
        setConfirmedId(data.id);

        setInitialized(true);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (!initialized) return;
        const data = {
            id: confirmedId,
        };

        onChange(data);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [confirmedId]);

    return initialized ? (
        <ThemeProvider theme={lightTheme}>
            <Card sx={{ mt: 1, mb: 2 }}>
                <CardContent>
                    <Box sx={{ display: "flex", alignItems: "center", height: "40px" }}>
                        <Box>
                            <Typography sx={{ display: "inline-block" }}>Unique identifier: </Typography>
                        </Box>
                        <Box sx={{ ml: 1, flex: 1 }}>
                            {edit ? (
                                <TextField
                                    value={id}
                                    onChange={(e) => setId(e.currentTarget.value)}
                                    fullWidth
                                    slotProps={{
                                        input: {
                                            endAdornment: (
                                                <>
                                                    <InputButton
                                                        size="small"
                                                        onClick={(e) => {
                                                            setConfirmedId(id);
                                                            setEdit(false);
                                                            e.stopPropagation();
                                                        }}
                                                    >
                                                        <CheckIcon className="h-5 w-5" />
                                                    </InputButton>

                                                    <InputButton
                                                        size="small"
                                                        onClick={(e) => {
                                                            setId(confirmedId);
                                                            setEdit(false);
                                                            e.stopPropagation();
                                                        }}
                                                    >
                                                        <XMarkIcon className="h-5 w-5" />
                                                    </InputButton>
                                                </>
                                            ),
                                        },
                                    }}
                                />
                            ) : (
                                <Typography
                                    component={EditableContent}
                                    variant="body2"
                                    sx={{
                                        fontWeight: 700,
                                        whiteSpace: "pre-wrap",
                                        p: 0,
                                        display: "flex",
                                        ml: 1,
                                        lineHeight: "unset !important",
                                    }}
                                >
                                    {id}
                                    <InputButton
                                        size="small"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setEdit(true);
                                        }}
                                    >
                                        <PencilIcon className="h-5 w-5" />
                                    </InputButton>
                                </Typography>
                            )}
                        </Box>
                    </Box>

                    <Typography variant="body2" color="text.secondary" sx={{ m: theme.spacing(3, 0, 2, 0) }}>
                        One or more content-blocks containing paragraphs and/or images
                    </Typography>
                </CardContent>
            </Card>
        </ThemeProvider>
    ) : null;
};
